import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Grid Toolbar Component (search, templates, etc in AG Grids)
import { GridToolbarComponent } from '../grid-toolbar/grid-toolbar.component';
import { AgGridAngular } from 'ag-grid-angular';

// Angular Material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

// Others modules
import { CommonPipesModule } from 'app/pipes/common-pipes.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileUploadModule } from 'ng2-file-upload';
import { MarkdownModule } from 'ngx-markdown';

import { ThemeService } from '../../services/theme/theme.service';

import { TopbarComponent } from './topbar/topbar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadDropDialogComponent } from './file-upload-drop-dialog/file-upload-drop-dialog.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { HistoryComponent } from './history/history.component';
import { HistoryDialogComponent } from './history-dialog/history-dialog.component';
import { HistoryRowDialogComponent } from './history-row-dialog/history-row-dialog.component';
import { FrameComponent } from './iframe/frame.component';
import { MultiSelectComponent } from '../multi-select/multi-select.component';
import { ResetComponent } from './reset/reset.component';
import { SessionTimedOutComponent } from './session-timed-out/session-timed-out.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ManageViewsDialogComponent } from '../grid-toolbar/manage-views-dialog/manage-views-dialog.component';
import { ViewSettingsDialogComponent } from '../grid-toolbar/view-settings-dialog/view-settings-dialog.component';
import { ReleaseNotesDialog } from './release-notes-dialog/release-notes-dialog';

@NgModule({
  declarations: [
    MultiSelectComponent,
    FrameComponent,
    FileUploadComponent,
    PieChartComponent,
    HistoryComponent,
    HistoryDialogComponent,
    HistoryRowDialogComponent,
    SupportTicketComponent,
    SpinnerComponent,
    TopbarComponent,
    NavigationComponent,
    NotificationsComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbComponent,
    FileUploadDropDialogComponent,
    ResetComponent,
    SessionTimedOutComponent,
    GridToolbarComponent,
    ConfirmDialogComponent,
    ManageViewsDialogComponent,
    ViewSettingsDialogComponent,
    ReleaseNotesDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AgGridAngular,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatRadioModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatSnackBarModule,
    MatGridListModule,
    MatToolbarModule,
    MatTimepickerModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatNativeDateModule,
    MatTabsModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    DragDropModule,
    FileUploadModule,
    CommonPipesModule,
    MarkdownModule
],
  exports: [
    MultiSelectComponent,
    FrameComponent,
    FileUploadComponent,
    CommonModule,
    PieChartComponent,
    HistoryComponent,
    SpinnerComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AgGridAngular,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatRadioModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatSnackBarModule,
    MatGridListModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatNativeDateModule,
    MatTabsModule,
    MatDividerModule,
    MatTimepickerModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    DragDropModule,
    FileUploadModule,
    CommonPipesModule,
    GridToolbarComponent,
    ConfirmDialogComponent,
  ],
  providers: [ThemeService, {
    provide: MatDialogRef,
    useValue: {}
  },],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppCommonModule {}